module.exports = __webpack_public_path__ + "static/media/LazyAz_web4_preview.85746898.jpg";